<template>
  <v-dialog
  max-width="1000" 
  v-model="dialog"
  @click:outside="$emit('changeValue', false)"
  >
    <v-card>
      <v-card-title> Pré Importação </v-card-title>
      
        <v-data-table
        class="px-6"
        :headers="headers"
        :items="indicesPreview"
        :search.sync="search"
        >
          <template v-slot:[`item.codigo`]="{ item }">{{ item.codigo}} </template>
          <template v-slot:[`item.variacao`]="{ item }">{{ item.variacao}} </template>
        </v-data-table>
      
      <v-card-actions>
          <v-col>
            <v-btn
            color="green" 
            @click="processarImportacao(arquivoId)"
            :loading="loading"
            style="float: right"
            >
              Importar
            </v-btn>
          </v-col>
          <v-btn 
          color="green" 
          style="float: right"
          @click="$emit('changeValue', false)"
          >
            Cancelar
          </v-btn>
      
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>

import IndicesCOGE from "@/services/IndicesCOGEService";

export default {
  props: {
    showDialog: {
      type: Boolean,
      required: true,
    },
    indicesPreview : {
      type: Array,
      required: true,
    },
    arquivoId:{
      type: Number,
      required: true,
    }
  },

  data() {
    return {
      search: "",
      dialog: false,
      loading: false,
      headers: [
        {
          text: "Códigos",
          value: "codigo"
        },
        {
          text: "Variação",
          value: "variacao"
        }
      ]
    }
  },

  watch: {
    showDialog(newValue){
      this.dialog = newValue
    }
  },

  methods: {
    processarImportacao(arquivoId) {
        this.loading = true;
      IndicesCOGE.processarImportacao(arquivoId)
        .then(response => {
          this.$toast.success(response.data.msg, "", { position: "topRight" })
          this.$router.push({ name: 'Indice COGE Histórico' })
        })
        .catch(err => {
          this.$toast.erro("Erro ao importar Indice COGE", "", { position: "topRight" })
          console.error(err)
        })
        .finally(() => {
          this.dialog = false;
        });
      
    }
  }

};
</script>

